import { Container } from './container';
import { SupplyChainDestination } from './supplyChainDestination';

export class Warehouse {
  id?: number;
  name?: string;
  lat?: number;
  lng?: number;
  type?: string;
  internal?: boolean;
  colorR?: number;
  colorG?: number;
  colorB?: number;
  areaRadius?: number; // in metri
  containers?: Array<Container>;
  supplyChainDestination?: SupplyChainDestination;
  address?: string;
  city?: string;
  country?: string;
  countryCode?: string;
  province?: string;
  cap?: string;
  tags?: Array<string>;
  balance?: number;

  constructor() {
    this.id = null;
    this.name = null;
    this.lat = null;
    this.lng = null;
    this.type = null;
    this.internal = true;
    this.colorR = null;
    this.colorG = null;
    this.colorB = null;
    this.areaRadius = null;
    this.containers = null;
    this.supplyChainDestination = null;
    this.address = null;
    this.city = null;
    this.country = null;
    this.countryCode = null;
    this.province = null;
    this.cap = null;
    this.tags = null;
    this.balance = null;
  }
}

/*
*********** MODELLO DI BACKEND **********************

package com.xfarm.api.v1.core

import com.xfarm.api.v1.auth.User

class Warehouse {
    transient springSecurityService

    Long    companyId = -1
    string name
    Double lat
    Double lng
    Date    dateCreated
    Date    lastUpdated

    static hasMany = [containers: Container]

    static constraints = {
        name blank: false, nullable: false
        lat  nullable: true
        lng  nullable: true
    }

    static mapping = {
        autoTimestamp true
    }

    def beforeInsert() {
        companyId = User.get(springSecurityService?.principal?.id)?.farm?.id
    }

    def beforeUpdate() {
        if(companyId != User.get(springSecurityService?.principal?.id)?.farm?.id){
            return false
        }
    }
}

*/
